export const BBMSL_SIGN_UP = 'BBMSL';
export const XERO_SIGN_UP = 'XERO';
export const XERO_LOGIN = 'XERO';
export const SHOPIFY_SIGN_UP = 'SHOPIFY';
export const SHOPLAZZA_SIGN_UP = 'SHOPLAZZA';
